import type { ResumeContent } from '../types'

export const resumeContent: ResumeContent = {
  professionalSummary: 'I have an established background in technical support operations, cybersecurity principles, network systems, incident management and workflow optimizations. Actively dedicated to evaluating AI models, integrating AI products into business operations and developing practical solutions that improve productivity, processes and support workflows. I provide AI consultations and workshops that help individuals and teams identify operational challenges, ask better questions, select effective tools, and apply AI to real workplace needs. I specialize in translating complex AI technologies into simple, digestible, and manageable solutions that can be implemented immediately.',
  experience: [
    {
      role: 'Help Desk Technology Analyst',
      company: 'uBreakiFix by Asurion',
      dates: '2019 to Present',
      focus: 'Technology Operations Support | Problem Management | Data Analysis',
      highlights: [
        'Monitor system performance and user reported issues, conducting in depth root cause analysis for recurring incidents and contributing to incident response improvements that reduced departmental mean time to resolution by 20%.',
        'Develop and automate Power BI operational reports that track incident frequency, resolution times, system health, and support performance.',
        'Implemented major incident identification and triage processes using internal monitoring tools and system logs, enabling earlier detection of outages and reducing downtime by 40%.',
        'Collaborate with engineering teams, stakeholders, and support personnel to refine incident escalation, problem management, and cross department communication workflows.',
        'Identified a security vulnerability caused by inadequate user identification controls and provided system hardening recommendations to prevent unauthorized password resets.',
        'Integrated AI into operational support workflows using Jira’s Rovo Agent to automatically generate support tickets from end user input and recommend solutions using internal knowledge base content.',
        'Enhanced user self service capabilities through AI integration, reducing incoming contact volume by 27% and helping support analysts decrease average handle time by more than 45% through automated ticket creation and faster access to accurate information.',
      ],
    },
  ],
  consultingHighlights: [
    'Provide consultations and workshops on the practical use of artificial intelligence in the workplace, helping individuals and teams identify challenges that can be addressed through AI.',
    'Guide users in structuring problems, asking more effective questions, and selecting appropriate AI products to improve productivity, business processes, and operational workflows.',
    'Evaluate emerging AI models, platforms, products, and integration tools through continuous hands on testing to identify solutions that are effective, accessible, and easy to implement.',
    'Translate complex AI concepts and technologies into clear, digestible, and manageable tools that can be applied immediately by users with varying levels of technical experience.',
    'Develop and demonstrate practical AI enabled solutions for information retrieval, workflow improvement, task automation, technical support, and workplace productivity.',
    'Provide step by step guidance that helps users build confidence, improve their understanding of AI, and develop the practical skills needed to use AI professionally.',
    'Help organizations move beyond general AI experimentation by connecting AI capabilities to specific operational problems, measurable improvements, and real world use cases.',
  ],
  expertise: [
    {
      title: 'Artificial Intelligence & AI Solutions',
      description: 'AI models, generative AI platforms, AI product evaluation, AI integrations, workplace AI adoption, solution development, prompt design, knowledge retrieval, user self service, workflow optimization, and AI assisted automation.',
    },
    {
      title: 'Cybersecurity Operations',
      description: 'Risk assessments, vulnerability management, threat analysis, ISO 27001 concepts, SIEM monitoring, log analysis, endpoint detection platforms, and system health monitoring. Tools include Splunk, Nessus, OpenVAS, Wireshark, and EDR platforms.',
    },
    {
      title: 'Incident Response & Problem Management',
      description: 'Incident identification, triage, escalation, root cause analysis, major incident management, and post incident reporting within Agile and ITIL aligned environments.',
    },
    {
      title: 'Networking & Infrastructure',
      description: 'TCP/IP, DNS, DHCP, VPNs, VLANs, NAT, and firewall configurations. Tools include Nmap, Netcat, TCPDump, traceroute, nslookup, and iperf.',
    },
    {
      title: 'Systems Administration & Identity Management',
      description: 'Windows, Linux, including Ubuntu and Kali, and macOS; secure system configuration; Active Directory user and group management; Group Policy Objects; LDAP; and multifactor authentication concepts.',
    },
    {
      title: 'Scripting, Automation & Data Analysis',
      description: 'PowerShell, Bash, Python, SQL, Excel VBA, Power BI, Excel, and Jira JQL for task automation, data querying, reporting, visualization, and workflow improvement.',
    },
    {
      title: 'IT Service Management & Collaboration',
      description: 'Jira, ServiceNow, technical documentation, workflow coordination, stakeholder communication, and collaboration between users, support teams, and engineering teams.',
    },
    {
      title: 'Virtualization',
      description: 'VMware and Proxmox virtualization platforms.',
    },
  ],
  education: [
    {
      degree: 'Bachelor of Applied Science in Computing Technology and Software Development',
      institution: 'Valencia College',
      location: 'Orlando, Florida',
    },
    {
      degree: 'Associate of Science in Cybersecurity and Network Engineering Technology',
      institution: 'Valencia College',
      location: 'Orlando, Florida',
    },
  ],
}
